import { Injectable } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { ResponseService } from 'src/app/modals/response/response-service.model';
import { filter, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Title } from '@angular/platform-browser';
import { LocalStorageService } from './local-storage.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })

export class RouterService {

      siteName: string = environment.name;

    constructor(    
        private activatedRoute: ActivatedRoute,
        private titleService: Title,
        private router: Router,
        private localStorageService: LocalStorageService,
        private translate: TranslateService
    ) {}

    triggerRoute(response:ResponseService | null, gotoUrl='/', params={}){
        
        //In router.service.ts
        if(response){
            if(response.handlecode === 1111){
                this.localStorageService.setItem('2fa_status', "0");
                this.router.navigate(['auth/two-factor-enable'], { "queryParams": params});
            }
            else if(response.handlecode === 3333){
                this.localStorageService.setItem('2fa_status', "1");
                this.router.navigate(['auth/two-factor'], { "queryParams": params});
            }
            else if(response.handlecode === 4444){
                this.localStorageService.setItem('2fa_status', "2");
                this.router.navigate(['auth/setup-password'], { "queryParams": params});
            }
            else{
                this.localStorageService.setItem('2fa_status', "3");
                this.router.navigate([gotoUrl], { "queryParams": params});
            }
        }else{
            if(gotoUrl !== "auth/login"){
                this.localStorageService.setItem('2fa_status', "3");
            }
            this.router.navigate([gotoUrl], { "queryParams": params});
        }
    }

    //Getting route that is set within *.routing.ts files 
    setupPageTitles(){
        this.router.events
            .pipe(
                filter((event) => event instanceof NavigationEnd),
                map(() => {
                    let route = this.activatedRoute;
                    while (route.firstChild) {
                        route = route.firstChild;
                    }
                    return route.snapshot.data['title'];
                })
            )
            .subscribe((pageTitle) => {
                if (pageTitle) {
                    this.translate.get(pageTitle).subscribe((translatedTitle: string) => {
                        this.titleService.setTitle(translatedTitle + " | " + this.siteName);
                    });
                    // const pageTitleTranslated = this.translate.instant(pageTitle);
                    // this.titleService.setTitle(pageTitleTranslated +" | "+ this.siteName);
                }else{
                    this.titleService.setTitle(this.siteName);
                }
            });
    }
}